import { SVGProps } from 'react'

const ChevronDownIcon = ({ className = 'text-[#959699]', ...props }: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            {...props}
        >
            <path
                d='M4.25 6L8.25 10L12.25 6'
                stroke='currentColor'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default ChevronDownIcon
